import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { CurrentUserService } from '../services/current-user.service';


@Injectable()
export class IsAdmin implements CanActivate {

  constructor(private _currentUserService: CurrentUserService) { }

  canActivate() {
    return this._currentUserService.getUser().map(u => u.isAdmin);
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/isAdmin.ts